import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import axios from "../../../axios/index"

// styles
import styles from "./Aboutus.module.css"
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css"

// components
import HomeNavbar from '../HomeNavbar/HomeNavbar';
import AboutusHeader from './AboutusHeader/AboutusHeader';
import Footer from "../Footer/Footer";
import AboutusText from './AboutusText/AboutusText';
import AboutusTeam from './AboutusTeam/AboutusTeam';

const Aboutus = () => {
    const [data, setData] = useState([])
    const [teamData, setTeamData] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const getData = async () => {
            const getAboutusData = await axios.get("AboutUs/GetAboutUsData");
            const getTeamData = await axios.get("AboutUs/GetTeamUsers");
            // console.log(getAboutusData)

            setData(getAboutusData.data.data)
            setTeamData(getTeamData.data.data)


            setIsLoading(false)
        }
        getData()

    }, [])

    return (
        <>
            <Helmet>
                <title>درباره ما | آذر ملک</title>
                <meta name="description" content="درباره آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="keywords" content=
                    "اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز" />
                <meta content="index , follow" name="robots" />
                <meta name="og:title" content="درباره آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="description" content="درباره آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="og:description" content="درباره آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta rel="canonical" href="https://azrmelk.com/درباره-ما" />
                <meta content="website" property="og:type" />
                <meta content="https://azrmelk.com" name="twitter:site" />
                <meta content="https://azrmelk.com/درباره-ما" property="og:url" />
            </Helmet>
            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className="d-flex justify-content-center align-items-start vw-100">
                        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                            <HomeNavbar Aboutus />
                            <main className="container py-3 px-0">
                                <div
                                    className="w-100 d-flex justify-content-start flex-wrap align-items-center mt-3 px-md-2 px-3"
                                    dir="rtl"
                                >
                                    <div className='d-flex align-items-center justify-content-center mt-2 mb-4'>
                                        <h1 className={styles.title}>
                                            درباره آذرملک
                                        </h1>
                                    </div>
                                    <section className='w-100 mb-5'>
                                        <AboutusHeader data={data} />
                                    </section>
                                    <AboutusText data={data} />
                                    <div className='d-flex align-items-center justify-content-center mt-2 mb-4'>
                                        <h2 className={styles.title}>
                                            تیم ما
                                        </h2>
                                    </div>
                                    <AboutusTeam teamData={teamData} />
                                </div>
                            </main>
                            <Footer />
                        </div>
                    </div>
                )}
        </>
    );
};

export default Aboutus;